import { actions } from '../constants/helpdesk';
import * as actionTypes from '../../models/action/helpdesk';
import { IAction } from '../../models/action/core';

import { Log } from 'ng2-logger';
import { boolean } from 'yup';
import { IHelpdeskFilter, IHelpDeskListProps } from '../../models/pages/helpdesk';
import { IPagedQueryS } from '../../models/components/paginate';
import { IHelpdeskListGetAction } from '../../models/action/helpdesk';

const _logger = Log.create('helpdeskts');
// #region Add Lti Action
export function getHelpdeskList(
    helpDeskStatus : string,
    HelpDeskCategoryId:string,
    subject :string,
    beginCreatedDate:Date|string,
    endCreatedDate:Date|string,
    createdDate: any,
    take:number,
    page:number,
    orderBy: string
): actionTypes.IHelpdeskGetAction {
    return {
        timestamp: Date.now(),
        type: actions.GET_HELPDESK_LIST,
        helpDeskStatus,
        HelpDeskCategoryId,
        subject,
        beginCreatedDate,
        endCreatedDate,
        createdDate,
        take,
        page,
        orderBy
    };
}
export function setHelpdeskList(
    helpDeskList: Array<any>,
    page:number,
    take:number,
    totalCount:number,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    callback?: (value: boolean) => void
): actionTypes.IHelpdeskSetAction {
    return {
        helpDeskList,
        page,
        take,
        totalCount,
        timestamp: Date.now(),
        type: actions.SET_HELPDESK_LIST,
        spinnerId,
        spinnerType,
        callback
    };
}
export function getHelpdeskMessage(
    HelpDeskId:string,
    take: number,
    skip: number,
): actionTypes.IHelpdeskChatGetAction {
    return {
        HelpDeskId,
        take,
        skip,
        timestamp: Date.now(),
        type: actions.GET_HELPDESK_MESSAGE,
    };
}
export function setHelpDeskMessage(
    helpDeskChat: Array<any>,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    callback?: (value: boolean) => void
): actionTypes.IHelpdeskMessageSetAction {
    return {
        helpDeskChat,
        timestamp: Date.now(),
        type: actions.SET_HELPDESK_MESSAGE,
        spinnerId,
        spinnerType,
        callback
    };
}

export function getHelpdeskCreate(

    Subject?: string,
    CategoryId?: string,
    Message?: string,
    FileUploadId?: string,
    callback?: (value: boolean) => void
): actionTypes.IHelpdeskCreateGetAction {
    return {
        type: actions.POST_HELPDESK_CREATE,
        timestamp: Date.now(),
        Subject,
        CategoryId,
        Message,
        FileUploadId,
        callback
    };
}
export function setHelpdeskCreate(
    helpDeskCreate: Array<any>,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    callback?: (value: boolean) => void
): actionTypes.IHelpdeskCreateSetAction {
    return {
        helpDeskCreate,
        timestamp: Date.now(),
        type: actions.SET_HELPDESK_CREATE,
        spinnerId,
        spinnerType,
        callback
    };
}


export function setHelpdeskAssignedUser(
    userId?: string,
    userName?: string,
    firstName?: string,
    lastName?: string,
    email?: string
): actionTypes.IHelpdeskAssignedUserSetAction {
    return {
        timestamp: Date.now(),
        type: actions.SET_HELPDESK_ASSIGNEDUSER,
        userId,
        userName,
        firstName,
        lastName,
        email
    };
}